import { Link } from "react-router-dom";
import { scrollToSectionEvent } from "../../helpers/utilities";
import { useLocation } from 'react-router-dom'
import { useState } from "react";

export default function NavMenu() {

    const location = useLocation();
    
    const [isOpen, setIsOpen] = useState(false);
    
    function toggleNav() {
        setIsOpen(!isOpen);
    }

    return (
        <>
            <nav className={isOpen === true ? " open" : ""}>
                <ul className="nav-menu">
                    <li><Link className={location.pathname === "/" ? "active" : ""} to="/" onClick={(e) => { scrollToSectionEvent(e, document.querySelector(".hero")); toggleNav(); } }>Home</Link></li>
                    <li><a href="/#about" onClick={(e) => { scrollToSectionEvent(e, document.querySelector(".about-panel")); toggleNav(); }}>About</a></li>
                    <li><a href="/#experience" onClick={(e) => { scrollToSectionEvent(e, document.querySelector(".experience-panel")); toggleNav(); }}>Experience</a></li>
                    <li><Link className={location.pathname.includes("/work") ? "active" : ""} to="/work" onClick={() => toggleNav()}>Work</Link></li>
                    <li><a href="/#github-projects" onClick={(e) => { scrollToSectionEvent(e, document.querySelector(".github-projects")); toggleNav(); }}>Projects</a></li>
                    <li><a href="/#contact" className="btn" onClick={(e) => { scrollToSectionEvent(e, document.querySelector(".contact-panel")); toggleNav(); }}>Get in touch</a></li>
                </ul>
            </nav>
            <div className={"hamburger" + (isOpen === true ? " open" : "")} onClick={toggleNav}>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </>
    );
}
